import React, { useId } from 'react';
import { Box, Checkbox, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';
import { COMMUNITY_JOB_FUNCTION_OPTIONS } from '../../constants/communityCategories';

export const interestDialogStyles = {
  '& .MuiDialogTitle-root': { px: 3, pt: 3, pb: 2 },
  '& .MuiDialogContent-root': { px: 3, pb: 3 },
  '& .MuiDialogActions-root': { px: 3, py: 2, minHeight: 72, justifyContent: 'space-between', borderTop: '1px solid', borderColor: 'divider' },
  '& .MuiTypography-root': { letterSpacing: 0 },
  '& .MuiButton-root': { minHeight: 40, textTransform: 'none' },
  '& .MuiInputBase-root': { fontSize: '1rem' },
};

export const interestLabelSx = {
  position: 'static', transform: 'none', mb: 1, fontSize: '1rem', fontWeight: 600,
  color: 'text.primary', lineHeight: 1.5, whiteSpace: 'normal',
  '&.Mui-focused': { color: 'text.primary' },
};

export default function TopicInterestField({ value, onChange, error = '', disabled = false }) {
  const id = useId();
  return (
    <FormControl fullWidth error={Boolean(error)} disabled={disabled}>
      <InputLabel id={`${id}-label`} sx={interestLabelSx}>Topics of interest</InputLabel>
      <Select
        labelId={`${id}-label`}
        multiple
        displayEmpty
        value={value}
        onChange={(event) => onChange(typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value)}
        inputProps={{ 'aria-describedby': `${id}-help`, 'aria-required': true }}
        renderValue={(selected) => selected.length ? (
          <Box sx={{ whiteSpace: 'normal', overflowWrap: 'anywhere', lineHeight: 1.5 }}>{selected.join(', ')}</Box>
        ) : <Box component="span" sx={{ color: 'text.secondary' }}>Choose your topics</Box>}
        MenuProps={{ PaperProps: { sx: { maxHeight: 320 } } }}
      >
        {COMMUNITY_JOB_FUNCTION_OPTIONS.map((topic) => (
          <MenuItem key={topic} value={topic} sx={{ whiteSpace: 'normal' }}>
            <Checkbox checked={value.includes(topic)} size="small" />
            <ListItemText primary={topic} />
          </MenuItem>
        ))}
      </Select>
      <FormHelperText id={`${id}-help`} role={error ? 'alert' : undefined} sx={{ mx: 0, mt: 1, fontSize: '0.875rem', lineHeight: 1.5, color: error ? 'error.main' : 'text.secondary' }}>
        {error || 'Select one or more. You can change these in your profile anytime.'}
      </FormHelperText>
    </FormControl>
  );
}
